import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CashAccountBalanceItemDTO  {
    _originalTypeClassName = "zERP.BO.CashAccountBalanceItemDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CashAccountBalanceItemDTO.translate = translateService;
}
this.Reason = null;
this.CashAccountBalanceItemDTOKey = null;
this._key = this.CashAccountBalanceItemDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Reason:any;
Cash:any;
POS:any;
Checks:any;
private _CashAccountBalanceItemDTOKey:any;
get CashAccountBalanceItemDTOKey(): any {
    return this._CashAccountBalanceItemDTOKey;
  }
set CashAccountBalanceItemDTOKey(value: any) {
    this._CashAccountBalanceItemDTOKey = value;
    this._key = value;
  }
static setCash = ($this, value) => {
var oldValue = $this.Cash;
$this.Cash = value;
if (value != null) {
}
}
static setPOS = ($this, value) => {
var oldValue = $this.POS;
$this.POS = value;
if (value != null) {
}
}
static setChecks = ($this, value) => {
var oldValue = $this.Checks;
$this.Checks = value;
if (value != null) {
}
}

static CreateEmpty(reason: any): any{if (reason == null) {reason = "";}
let item = new Domain.CashAccountBalanceItemDTO();
item.Reason = reason;
Domain.CashAccountBalanceItemDTO.setCash(item, new Domain.CashAccountBalancePaymentTypeDTO());
item.Cash.ReceivedInvoicesNumber = 0;
item.Cash.ReceivedAmount = 0;
item.Cash.PaidInvoicesNumber = 0;
item.Cash.PaidAmount = 0;
Domain.CashAccountBalanceItemDTO.setPOS(item, new Domain.CashAccountBalancePaymentTypeDTO());
item.POS.ReceivedInvoicesNumber = 0;
item.POS.ReceivedAmount = 0;
item.POS.PaidInvoicesNumber = 0;
item.POS.PaidAmount = 0;
Domain.CashAccountBalanceItemDTO.setChecks(item, new Domain.CashAccountBalancePaymentTypeDTO());
item.Checks.ReceivedInvoicesNumber = 0;
item.Checks.ReceivedAmount = 0;
item.Checks.PaidInvoicesNumber = 0;
item.Checks.PaidAmount = 0;
return item;
}
static Update(item: any,isIncome: any,paymentType: any,amount: any): any{let paymentTypeItem = new Domain.CashAccountBalancePaymentTypeDTO();
switch (paymentType) {case "CASH":
{
paymentTypeItem = item?.Cash;break;}
case "POS":
{
paymentTypeItem = item?.POS;break;}
case "CHECK":
{
paymentTypeItem = item?.Checks;break;}
}
if (isIncome) {paymentTypeItem.ReceivedInvoicesNumber = Joove.Common.safeNumber(paymentTypeItem?.ReceivedInvoicesNumber) + Joove.Common.safeNumber(1);paymentTypeItem.ReceivedAmount = Joove.Common.safeNumber(paymentTypeItem?.ReceivedAmount) + Joove.Common.safeNumber(amount);}else {paymentTypeItem.PaidInvoicesNumber = Joove.Common.safeNumber(paymentTypeItem?.ReceivedInvoicesNumber) + Joove.Common.safeNumber(1);paymentTypeItem.PaidAmount = Joove.Common.safeNumber(paymentTypeItem?.ReceivedAmount) + Joove.Common.safeNumber(amount);}
return item;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CashAccountBalanceItemDTOKey == null || $this.CashAccountBalanceItemDTOKey == 0;
            }


}